const YOUTUBE_PATH_PREFIX_TO_UPDATE = [
    'www.youtube.com/watch?v=',
    'www.youtube.com/embed/',
    'www.youtube.com/v/',
    'youtu.be/'
];
const YOUTUBE_NOCOOKIE_DOMAIN = 'www.youtube-nocookie.com/embed/';
/**
 * Utility to modify youtube urls to use youtube-nocookie domain
 *
 * @param {string} url - any url
 * @returns {string} - youtube NO COOKIE url OR original url if no match found
 */
function updateYoutubeURLWithNoCookieVariant(url) {
    // do nothing if url is not a string
    if (typeof url !== 'string')
        return url;
    // look for match and update if found
    for (const path of YOUTUBE_PATH_PREFIX_TO_UPDATE) {
        if (url.includes(path)) {
            return url.replace(path, YOUTUBE_NOCOOKIE_DOMAIN);
        }
    }
    // pass back original url if no match found
    return url;
}

export { updateYoutubeURLWithNoCookieVariant };
//# sourceMappingURL=youtube-nocookie.js.map
